'use strict';
angular.module('webHeaderModule', []).controller('webHeaderCtrl', [
    '$scope',
    'localStorageService',
    '$state',
    'httpService',
    '$stateParams',
    '$interval',
    function ($scope, localStorageService, $state, httpService, $stateParams, $interval) {
        initStatus();
        initData();

        function initStatus() {
            var i = $stateParams.type;
            switch (i) {
                case '0':
                    $scope.type = '稿件详情';
                    break;
                case '1':
                    $scope.type = '新建公告';
                    break;
                case '2':
                    $scope.type = '编辑公告';
                    break;
                case '3':
                    $scope.type = '公告详情';
                    break;
                case '4':
                    $scope.type = '新建稿件';
                    break;
                case '5':
                    $scope.type = '编辑稿件';
                    break;
                case '6':
                    $scope.type = '编辑稿件-新闻';
                    break;
                case '7':
                    $scope.type = '编辑稿件-视频';
                    break;
                default:
                    $scope.type = '';
            }
            $scope.info = {};
            $scope.authentication = {
                0: '未认证',
                1: '已认证',
                2: '认证失败',
                3: '二次审核'
            };
            $scope.authenticationClass = {
                0: 'unaudited',
                1: 'green',
                2: 'failure',
                3: 'twoAudit'
            };
        }

        function initData() {
            getLogin();
            intervalGetMessage();
            window.addEventListener('storage', function (e) {
                if (e.key === 'ls.readMessage') {
                    unReadMessages();
                }
            });
            $scope.$on('readMessage', function () {
                unReadMessages();
            });
        }
        /**
         * [goTobackstage description] 进入后台
         * @return {[type]} [description]
         */
        $scope.goTobackstage = function () {
            var href = $state.href('backstage');
            window.open(href);
        };
        /**
         * [intervalGetMessage description] 间隔时间请求未读信息
         * @return {[type]} [description]
         */
        function intervalGetMessage() {
            var myInterval = $interval(unReadMessages, 30000);
            $scope.$on('$destroy', function () {
                $interval.cancel(myInterval);
            });
        }
        /**
         * [goToMessage description] 进入消息
         * @return {[type]} [description]
         */
        $scope.goToMessage = function () {
            var href = $state.href('index.settings.message');
            window.open(href);
        };
        /**
         * [logOut description] 注销
         * @return {[type]} [description]
         */
        $scope.logOut = function () {
            httpService.http('/mcnww/web/user/logout.do', '', 'post').then(function () {
                httpService.notLogin = false;
                $state.go('login', {
                    orgurl: $state.current.name,
                    orgparams: $stateParams
                });
            });
        };
        /**
         * [getLogin description] 获取登入详细
         * @return {[type]} [description]
         */

        function getLogin() {
            httpService.http('/mcnww/web/user/getLoginUser.do', '', 'post').then(function (data) {
                $scope.isAdmin = data.isAdmin;
                $scope.info = data.loginUser;
                var time = new Date().getTime();
                if (data.loginUser.logo) {
                    $scope.headPic = angular.globalConfig.pictureServer + data.loginUser.logo + '?v=' + time;
                } else {
                    $scope.headPic = './images/uperroe.png';
                }
                if (data.loginUser.userType == 1) {
                    $scope.message = true;
                    unReadMessages();
                } else {
                    $scope.message = false;
                }
                //  if(data.signChannels){
                //     $scope.authentication = true;
                // }
                $scope.status = data.auditStatus;
            });
        }
        /**
         * [unReadMessages description] 获取消息数字
         * @return {[type]} [description]
         */
        unReadMessages();

        function unReadMessages() {
            httpService.http('/mcnww/web/message/unReadMessages.do', '', 'post').then(function (data) {
                $scope.unReadmessages = data.unReadmessages;
            });
        }
        /**
         * [goToInformation description] 进入修改资料
         * @return {[type]} [description]
         */
        $scope.goToInformation = function () {
            var href = $state.href('index.settings.pgcmodifydata');
            window.open(href);
        };
        /**
         * [goToInformationUgc description] 进入ugc修改资料
         * @return {[type]} [description]
         */
        $scope.goToInformationUgc = function () {
            var href = $state.href('index.settings.modifydata');
            window.open(href);
        };
    }
]);
